import { useMemo } from 'react';
import { FeatureService } from './FeatureService';
import { useDynamicEntitiesContext } from '../../core/DynamicEntitiesProvider';

/**
 * `FeatureService` ya cableado con el `baseUrl` y el transporte del provider.
 *
 * Construirlo a mano con `new FeatureService(baseUrl)` deja la petición sin las
 * cabeceras del anfitrión; usar siempre este hook dentro de componentes.
 */
export const useFeatureService = (): FeatureService => {
    const { baseUrl, fetcher } = useDynamicEntitiesContext();
    return useMemo(() => new FeatureService(baseUrl, fetcher), [baseUrl, fetcher]);
};
